import { render, staticRenderFns } from "./NewsletterPopup.vue?vue&type=template&id=5c63be51&"
import script from "./NewsletterPopup.vue?vue&type=script&lang=js&"
export * from "./NewsletterPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports